<app-dialog
[title]="'restoreUser.header' | translate"
[confirmation]="'button.restoreUser' | translate"
[isValid]="enableRestore"
(save)="restoreUser()"
>
  <div id="restore-user">
    <div mat-dialog-content
         id="restore-user-content">
      <p>
        {{ 'restoreUser.content' | translate }}
      </p>
    </div>
    <p>{{ 'restoreUser.permissionDialog' | translate }}</p>
    <mat-divider></mat-divider>
    <ng-container *ngIf="!isLoadingData; else loader">
      <app-select-role-table [userUid]="userUid" [onSave]="saveSubject.asObservable()" [navPath]="navPath" (isValidSubject)="handleIsValidEvent($event)" (emitSaveDone)="closeDialog()"></app-select-role-table>
    </ng-container>

    <ng-template #loader>
      <ng-container *ngFor="let i of [].constructor(3)">
        <ngx-skeleton-loader [theme]="{ width: '100%', height: '50px', marginTop: '1.34375em' }"></ngx-skeleton-loader>
        <mat-divider></mat-divider>
      </ng-container>
    </ng-template>
  </div>
</app-dialog>